import * as React from "react"
import { Input as InputPrimitive } from "@base-ui/react/input"

import { cn } from "@/lib/utils"

function Input({ className, type, ...props }: React.ComponentProps<"input">) {
  return (
    <InputPrimitive
      type={type}
      data-slot="input"
      className={cn(
        "h-8 w-full min-w-0 rounded-[3px] border border-[#A6A9B0] bg-white px-3 py-1 text-[13px] text-[#000A1E] transition-colors outline-none",
        "placeholder:text-[rgba(0,10,30,0.4)]",
        "focus-visible:border-[#80858F] focus-visible:shadow-[0_0_0_1px_#fff,0_0_0_4px_rgba(0,10,30,0.5)] focus-visible:outline-[1px_solid_transparent]",
        "file:inline-flex file:h-6 file:border-0 file:bg-transparent file:text-[13px] file:font-medium file:text-[#000A1E]",
        "disabled:pointer-events-none disabled:cursor-not-allowed disabled:bg-[#F2F3F4] disabled:opacity-50",
        "aria-invalid:border-[#CC0000] aria-invalid:shadow-[0_0_0_1px_#fff,0_0_0_4px_rgba(204,0,0,0.2)]",
        className
      )}
      style={{ fontFamily: '"Helvetica Neue", Arial, sans-serif' }}
      {...props}
    />
  )
}

export { Input }
